import MetaData from  '../../mixins/meta-data.js'

export default {
	mixins: [MetaData],
	props: {
		item: Object,
		promo: Boolean,
		competition: Boolean,
		event: Boolean,
		movie: Object,
		festival: Boolean
	},

	data() {
		return {
			dialogActive: false,
			imgSrc: ''
		}
	},

	methods: {
    continueToDetails(id) {
        this.$router.push('/film-festival-details/' + id);
    },
    getImages() {
    	if (this.competition) {
    		if (this.item.image) {
    				if (this.item.image.url) this.imgSrc = 'background-image:url(' + this.item.image.url + ')' 
    				else this.imgSrc = 'background-image:url(/static/img/movie-summary-default-bg.jpg)'
    		}
    	} else {
    		if (this.item.images.background) {
    				if (this.item.images.background.url) this.imgSrc = 'background-image:url(' + this.item.images.background.url + ')' 
    				else this.imgSrc = 'background-image:url(/static/img/movie-summary-default-bg.jpg)'
    		}
    	}
    }
	},
	created() {
		if (this.promo) {
			this.metaTitle = 'Promotions'
			this.metaDescription = 'Promotions'
		}
		if (this.competition) {
			this.metaTitle = 'Competitions'
			this.metaDescription = 'Competition'
		}
		if (this.event) {
			this.metaTitle = 'Events'
			this.metaDescription = 'Events'
		}
		this.getImages()
	}

}


// WEBPACK FOOTER //
// ./src/components/exclusive-to-sk/exclusive-list.js